<div class="faq-container" data-test="faq-container">
  <div class="faq-content">
    <div class="faq-list">
      <expandable-panel *ngFor="let qaPair of frequentlyAskedQuestionList;"
        [panelHeaderText]="qaPair.question"
        [expandableBodyText]="qaPair.answer"
      ></expandable-panel>
    </div>
    <div class="more-questions-section">
      <div>
        More questions?
      </div>
      <div class="general-faq-link">
        <a href="https://www.sondermind.com/faqs">Our FAQs can answer them!</a>
      </div>
    </div>
  </div>
</div>
  